<template>
  <div :class="['mainHeader', { enHeader: isEn || isVn }]">
    <div class="title">
      <img :src="titleImg" alt="">
    </div>
    <div :class="['match-team', { 'match-team-video': showVideo && videoSrc }]">
      <!-- 视频播放 -->
      <div v-if="showVideo && videoSrc" class="video-player" @mouseenter="qualityVisible = true">
        <iframe
          allowfullscreen="allowfullscreen"
          webkitallowfullscreen="true"
          mozallowfullscreen="true"
          allowtransparency="true"
          auto="autoplay"
          muted="muted"
          allow="autoplay"
          :src="videoSrc"
          class="video-iframe"
          ref="videoIframe"
          @load="onIframeLoad"
        />
        <span class="video-close" @click="closeVideo">✕</span>
        <div class="video-quality" :class="{ visible: qualityVisible }" v-if="currentVideoItem && (currentVideoItem.vs.m3u8SD || currentVideoItem.vs.m3u8HD)">
          <span class="quality-btn" @click="videoBox = !videoBox">{{ videoTypeName }}</span>
          <ul v-if="videoBox" class="quality-list">
            <li v-if="currentVideoItem.vs.m3u8SD" @click="switchVideoType('m3u8SD')">{{ $t('home.sd') }}</li>
            <li v-if="currentVideoItem.vs.m3u8HD" @click="switchVideoType('m3u8HD')">{{ $t('home.hd') }}</li>
          </ul>
        </div>
      </div>
      <!-- 队伍分组 -->
      <template v-else>
        <div class="team-title">
          <!-- {{ $t('home.group48') }} -->
        </div>

        <div class="team">
          <div class="team-each">
            <div class="team-each-item" v-for="(item, index) in teamDataLeft" :key="index">
              <div class="no">{{ item.group }}</div>
              <div class="icon" :class="{noLine: child.eli}" v-for="(child, index) in item.children" :key="index">
                <img :src="child.logo" alt="">
              </div>
            </div>
          </div>
          <div class="team-each team-each-right">
            <div class="team-each-item" v-for="(item, index) in teamDataRight" :key="index">
              <div class="icon" :class="{noLine: child.eli}" v-for="(child, index) in item.children" :key="index">
                <img :src="child.logo" alt="">
              </div>
              <div class="no">{{ item.group }}</div>
            </div>
          </div>
        </div>
      </template>
    </div>

    <div class="swiper-container" ref="swiperContainer">
      <div class="swiper-wrapper">
        <div
          v-for="(item, index) in swiperData"
          :key="item.id || index"
          class="swiper-slide"
        >
          <div :class="['swiper-item', { 'swiper-item-active': activeSlideIndex === index }]" @click="slideTo(index)">
            <div class="swiper-header">
              <div class="video">
                <img v-if="item.vs && (item.vs.m3u8SD || item.vs.m3u8HD)" src="@/assets/imgs/header/video.png" alt="">
              </div>
              <span>{{ $t('home.Group Stage') }}</span>
              <div class="right-icon">
                <img src="@/assets/imgs/header/2026-logo.png" alt="">
              </div>
            </div>
            <div class="swiper-card">
              <div class="swiper-card-header">
                <div class="icon">
                  <img v-if="item.ts && item.ts[0]" :src="item.ts[0].lurl || require('@/assets/imgs/comm/team.svg')" alt="">
                  <img v-else src="@/assets/imgs/header/empty.png" alt="">
                </div>
                <div class="clock">
                  <img src="@/assets/imgs/header/clock.png" alt="">
                </div>
                <div class="icon">
                  <img v-if="item.ts && item.ts[1]" :src="item.ts[1].lurl || require('@/assets/imgs/comm/team.svg')" alt="">
                  <img v-else src="@/assets/imgs/header/empty.png" alt="">
                </div>
              </div>
              <div class="swiper-card-footer">

                <template v-if="item.ms === 5">
                  <span v-if="runtimeMap[item.id]">{{ runtimeMap[item.id].period }} {{ runtimeMap[item.id].time }}</span>
                  <span v-else-if="item.mc && item.mc.pe && match_period[item.mc.pe]">{{ match_period[item.mc.pe][getLocal()] }} {{ checkMcState(item) ? secTotime(item.mc.s) + "'" : '' }}</span>
                </template>
                <template v-else>
                  {{ item.bt ? formatMatchTime(item.bt) : '' }}
                </template>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 倒计时 -->
    <div class="countdown">
      <div class="countdown-label">
        <span class="label-text">{{ countdownLabel }}</span>
        <span class="separator">:</span>
      </div>
      <div class="countdown-timer">
        <span class="digit">{{ day[0] }}</span>
        <span class="digit">{{ day[1] }}</span> 
        <span class="unit">{{ $t('home.Day') }}</span>
        <span class="digit">{{ hour[0] }}</span>
        <span class="digit">{{ hour[1] }}</span>
        <span class="unit">{{ $t('home.Hour') }}</span>
        <span class="digit">{{ minute[0] }}</span>
        <span class="digit">{{ minute[1] }}</span>
        <span class="unit">{{ $t('home.Minute') }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import Swiper from 'swiper'
import 'swiper/swiper.css'
import titleImg from '@/assets/imgs/header/title-zh.png'
import titleImgEn from '@/assets/imgs/header/title-en.png'
import titleImgVn from '@/assets/imgs/header/title-vn.png'
import fifa from '@/assets/imgs/header/fifa.png'
import { getTeamStatList } from "@/service/Integral";
import { getMatchListV1 } from "@/service/Schedule";
import { Format } from "@/utils/fn";
import { stList, match_period } from "@/utils/filedList";
import { mapState } from "vuex";
import empty from '@/assets/imgs/header/empty.png'
import { Stopwatch } from '@/utils/stopwatch'
import { getLang } from '@/utils/lng'

export default {
  name: "MainHeader",
  props: ["headerHeight"],
  data() {
    return {
      day: [0, 0],
      hour: [0, 0],
      minute: [0, 0],
      second: [0, 0],
      countDownTimer: null,
      isWorldCupStarted: false,
      matchListTimer: null,
      teamDataLeft: [],
      teamDataRight: [],
      match_period,
      swiperData: [],
      swiperInstance: null,
      showVideo: false,
      videoSrc: '',
      videoType: '',
      videoBox: false,
      qualityVisible: false,
      activeSlideIndex: -1,
      firstMatchTime: null,
      finalMatchTime: null,
      runtimeMap: {},
      stopwatchMap: {},
    };
  },
  methods: {
    getMatchList() {
      getMatchListV1({
        languageType: getLang(this.languageType),
        current: 1,
        leagueId: process.env.VUE_APP_LEAGUEID,
        // sportId: 177,
        orderBy: 0,
        sportType: [1, 2],
        type: 5,
        // type: 1,
        oddsType: 1,
      }).then((res) => {
        if (res.success && res.data && res.data.records) {
          this.swiperData = res.data.records
            .sort((a, b) => {
              if (!a.bt) return 1;
              if (!b.bt) return -1;
              return a.bt - b.bt;
            });

          // console.log('match list', this.swiperData);

          // // TODO: 模拟视频数据，测试完删除
          // if (this.swiperData.length > 0) {
          //   this.swiperData[0].vs = {
          //     web: 'https://test-video.fb9pro.com/live/index.html',
          //     m3u8SD: 'https://test-play.newsportspro.com/live/stream_1.m3u8',
          //   };
          // }

          this.initStopwatches();
          this.$nextTick(() => {
            if (!this.swiperInstance) this.initSwiper();
          });
        }
      });
    },
    formatMatchTime(btm) {
      const date = new Date(Number(btm));
      const today = new Date();
      if (date.getFullYear() === today.getFullYear() && date.getMonth() === today.getMonth() && date.getDate() === today.getDate()) {
        return Format(date, 'hh:mm');
      }
      return Format(date, 'MM/dd hh:mm');
    },
    getStatusText(ms) {
      const key = ms === undefined ? 4 : ms;
      return stList[key] ? stList[key][this.getLocal()] : '';
    },
    checkMcState(item) {
      const notSt = [1001, 1005, 1009, 1010, 1011, 1012, 1013, 1014, 1015, 1016];
      if (!item.mc || !item.mc.pe) return false;
      if (notSt.includes(item.mc.pe)) return false;
      if (item.mc.s === undefined || item.mc.s === null || item.mc.s === '') return false;
      return true;
    },
    secTotime(s) {
      if (s <= -1) return '00:00';
      var min = Math.floor(s / 60);
      var sec = s % 60;
      return (min < 10 ? '0' : '') + min + ':' + (sec < 10 ? '0' : '') + sec;
    },
    initStopwatches() {
      this.swiperData.forEach(item => {
        if (item.ms === 5 && this.checkMcState(item)) {
          this.startItemStopwatch(item);
        } else if (this.stopwatchMap[item.id]) {
          this.stopItemStopwatch(item.id);
        }
      });
    },
    startItemStopwatch(item) {
      const id = item.id;
      let { s: second, pe: period, r: running } = item.mc;
      const min = Math.floor(second / 60);
      const sec = second % 60;
      const periodText = match_period[period] ? match_period[period][this.getLocal()] : '';

      this.$set(this.runtimeMap, id, {
        period: periodText,
        time: `${String(min).padStart(2, '0')}:${String(sec).padStart(2, '0')}'`,
      });

      // 停掉旧的
      if (this.stopwatchMap[id]) {
        this.stopwatchMap[id].isStop = true;
        this.stopwatchMap[id].stop();
      }

      if (running) {
        const num = item.mc.tp == 1 ? 1 : -1;
        this.stopwatchMap[id] = new Stopwatch(() => {
          const rt = this.runtimeMap[id];
          if (!rt) return;
          const parts = rt.time.replace("'", '').split(':');
          let m = parseInt(parts[0]) || 0;
          let sc = parseInt(parts[1]) || 0;
          let totalSec = m * 60 + sc + num;
          if (item.mc.tp != 1 && totalSec <= 0) {
            totalSec = 0;
            this.stopItemStopwatch(id);
          }
          m = Math.floor(totalSec / 60);
          sc = totalSec % 60;
          this.$set(this.runtimeMap, id, {
            period: rt.period,
            time: `${String(m).padStart(2, '0')}:${String(sc).padStart(2, '0')}'`,
          });
        });
      }
    },
    stopItemStopwatch(id) {
      if (this.stopwatchMap[id]) {
        this.stopwatchMap[id].isStop = true;
        this.stopwatchMap[id].stop();
        delete this.stopwatchMap[id];
      }
    },
    clearAllStopwatches() {
      Object.keys(this.stopwatchMap).forEach(id => {
        this.stopItemStopwatch(id);
      });
      this.runtimeMap = {};
    },
    countDownDate() {
      const WORLD_CUP_START = new Date('2026-06-12T03:00:00+08:00').getTime();
      const WORLD_CUP_FINAL = new Date('2026-07-20T03:00:00+08:00').getTime();
      const now = Date.now();
      this.isWorldCupStarted = now >= WORLD_CUP_START;
      const target = this.isWorldCupStarted ? WORLD_CUP_FINAL : WORLD_CUP_START;
      let diff = target - now;
      if (diff <= 0) {
        diff = 0;
        if (this.countDownTimer) {
          clearInterval(this.countDownTimer);
          this.countDownTimer = null;
        }
      }
      const days = Math.floor(diff / (1000 * 60 * 60 * 24));
      const hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((diff % (1000 * 60)) / 1000);
      const day = String(days).padStart(2, '0');
      const hour = String(hours).padStart(2, '0');
      const minute = String(minutes).padStart(2, '0');
      const second = String(seconds).padStart(2, '0');
      this.day = [day[0], day[1]];
      this.hour = [hour[0], hour[1]];
      this.minute = [minute[0], minute[1]];
      this.second = [second[0], second[1]];
    },
    startCountDown() {
      this.countDownDate();
      this.countDownTimer = setInterval(this.countDownDate, 1000);
    },
    initSwiper() {
      if (this.$refs.swiperContainer) {
        this.swiperInstance = new Swiper(this.$refs.swiperContainer, {
          // modules: [FreeMode],
          slidesPerView: 3.15,
          spaceBetween: 4,
          freeMode: false,
          // centeredSlides: true,
          // loop: this.swiperData.length >= 8 ? true : false,
          // loopedSlides: Math.ceil(3.15) + 1, // 设置为 slidesPerView 向上取整 + 1，确保循环正常
          // centeredSlidesBounds: true,
          // initialSlide: 0,
        });

        this.swiperInstance.on('slideChangeTransitionEnd', () => {
          console.log('activeIndex', this.swiperInstance.activeIndex);
        });
      }
    },
    slideTo(index) {
      this.activeSlideIndex = index;
      if (this.swiperInstance) {
        this.swiperInstance.slideToLoop(index, 300);
      }
      this.playVideo(index);
    },
    playVideo(index) {
      const item = this.swiperData[index];
      if (!item || !item.vs || (!item.vs.m3u8SD && !item.vs.m3u8HD)) {
        this.closeVideo();
        return;
      }
      const vs = item.vs;
      // 初始化清晰度：优先标清
      if (vs.m3u8SD) {
        this.videoType = 'm3u8SD';
      } else {
        this.videoType = 'm3u8HD';
      }
      this.buildVideoSrc();
      this.showVideo = true;
    },
    buildVideoSrc() {
      const item = this.swiperData[this.activeSlideIndex];
      if (!item || !item.vs) return;
      const vs = item.vs;
      const liveUrl = vs[this.videoType];
      if (!liveUrl || !vs.web) return;
      const muteText = this.$t('home.mute');
      const unmuteText = this.$t('home.unmute');
      const openPipText = this.$t('home.openMini');
      const fullscreenText = this.$t('home.fullscreen');
      const cancelFullscreenText = this.$t('home.cancelFullscreen');
      this.videoSrc = `${vs.web}?liveUrl=${encodeURIComponent(liveUrl)}&isMobile=true&mute=${muteText}&cancel_mute=${unmuteText}&open_pip=${openPipText}&fullscreen_text=${fullscreenText}&cancel_fullscreen_text=${cancelFullscreenText}&objectFit=cover`;
    },
    switchVideoType(type) {
      this.videoType = type;
      this.videoBox = false;
      this.buildVideoSrc();
    },
    onIframeLoad(e) {
      console.log('[load]', e)
      try {
        const iframeDoc = this.$refs.videoIframe.contentDocument || this.$refs.videoIframe.contentWindow.document;
        const video = iframeDoc.querySelector('video');
        if (video) {
          video.style.objectFit = 'cover';
        }
      } catch (e) {
        console.warn('iframe video style inject failed', e);
      }
    },
    closeVideo() {
      this.showVideo = false;
      this.videoBox = false;
      this.qualityVisible = false;
      this.videoSrc = '';
    },
    getTeamStatList() {
      // sph 到组名的映射: 14=A, 15=B, ..., 25=L
      const sphToGroup = {
        14: 'A', 15: 'B', 16: 'C', 17: 'D', 18: 'E', 19: 'F',
        20: 'G', 21: 'H', 22: 'I', 23: 'J', 24: 'K', 25: 'L',
      };
      const leftGroups = ['A', 'B', 'C', 'D', 'E', 'F'];
      const rightGroups = ['G', 'H', 'I', 'J', 'K', 'L'];

      getTeamStatList({ languageType: getLang(this.languageType) }).then((res) => {
        if (res.success && res.data) {
          // 筛选小组赛阶段数据 ph === 7
          const groupData = res.data.filter(item => item.ph === 7);
          // 按 sph 分组
          const grouped = {};
          groupData.forEach(item => {
            const groupName = sphToGroup[item.sph];
            if (!groupName) return;
            if (!grouped[groupName]) grouped[groupName] = [];
            grouped[groupName].push({
              logo: item.tlg ? (item.eli ? fifa : item.tlg) : empty,
              eli: item.eli
            });
          });

          this.teamDataLeft = leftGroups.map(group => ({
            group,
            children: grouped[group] || [],
          }));

          this.teamDataRight = rightGroups.map(group => ({
            group,
            children: grouped[group] || [],
          }));
        }
      });
    },
  },
  computed: {
    ...mapState(["common"]),
    currentVideoItem() {
      if (this.activeSlideIndex < 0 || !this.swiperData[this.activeSlideIndex]) return null;
      return this.swiperData[this.activeSlideIndex];
    },
    videoTypeName() {
      return this.videoType === 'm3u8HD' ? this.$t('home.hd') : this.$t('home.sd');
    },
    lang() {
      return this.$i18n.locale
    },
    languageType() {
      return this.common.languageType;
    },
    titleImg() {
      if(this.lang == 'en') {
        return titleImgEn
      } else if(this.lang == 'vn') {
        return titleImgVn
      } else {
        return titleImg
      }
    },
    countdownLabel() {
      return this.isWorldCupStarted ? this.$t('home.conntdown') : this.$t('home.worldcup');
    },
    isEn() {
      return this.$i18n.locale == "en";
    },
    isVn() {
      return this.$i18n.locale == "vn";
    }
  },
  created() {
    this.getTeamStatList();
    this.getMatchList();
    this.matchListTimer = setInterval(() => {
      this.getMatchList();
    }, 5000);
    this.startCountDown();
  },
  mounted() {
    
  },
  destroyed() {
    clearInterval(this.countDownTimer);
    this.countDownTimer = null;
    clearInterval(this.matchListTimer);
    this.matchListTimer = null;
    if (this.swiperInstance) {
      this.swiperInstance.destroy(true, true);
      this.swiperInstance = null;
    }
    this.closeVideo();
    this.clearAllStopwatches();
  }
};
</script>

<style lang="scss" scoped>
.mainHeader {
  width: 100%;
  height: 397px;
  background: url(../../assets/imgs/header/banner-bg.png) no-repeat;
  background-size: 100% 100%;
  color: var(--text-white-color);
  margin-bottom: -23px;
  // padding-top: 44px;
  position: fixed;
  top: 0;
  .title {
    margin: 0 auto;
    margin-top: 4px;
    text-align: center;
    img {
      width: 88px;
    }
  }

  .match-team {
    width: 94.67vw;
    height: 221px;
    background: url(../../assets/imgs/header/match-bg.png) no-repeat;
    background-size: 100% 100%;
    margin: 0 auto;
    margin-top: 6px;
    overflow: hidden;
    padding: 0 12px;
    position: relative;

    &.match-team-video {
      padding: 0;
    }

    .video-player {
      width: 100%;
      height: 100%;
      position: relative;

      // &:hover .video-quality,&:active .video-quality,&:visited .video-quality {
      //   opacity: 1;
      // }

      .video-iframe {
        width: 100%;
        height: 100%;
        border: none;
        border-radius: 4px;
        position: relative;
        z-index: 2;
      }

      .video-close {
        position: absolute;
        top: 6px;
        right: 6px;
        width: 20px;
        height: 20px;
        background: rgba(0, 0, 0, 0.5);
        border-radius: 50%;
        color: #fff;
        font-size: 12px;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        z-index: 100;
      }

      .video-quality {
        position: absolute;
        right: 80px;
        bottom: 10px;
        z-index: 100;
        opacity: 0;

        &.visible {
          opacity: 1;
        }
        // transition: opacity 0.3s;

        .quality-btn {
          display: block;
          height: 26px;
          line-height: 26px;
          padding: 0 8px;
          font-size: 12px;
          color: #fff;
          text-align: center;
          border-radius: 4px;
          background: rgba(0, 0, 0, 0.5);
          cursor: pointer;
        }

        .quality-list {
          position: absolute;
          bottom: 30px;
          left: 0;
          width: 100%;
          margin: 0;
          padding: 0;
          background: rgba(0, 0, 0, 0.8);
          border-radius: 4px;
          overflow: hidden;
          list-style: none;

          li {
            height: 26px;
            line-height: 26px;
            font-size: 12px;
            color: #fff;
            text-align: center;
            cursor: pointer;
            border-bottom: 1px solid rgba(255, 255, 255, 0.1);

            &:last-child {
              border-bottom: none;
            }
          }
        }
      }
    }
  }

  .team-title {
    color: var(--text-white-color);
    text-align: center;
    font-size: 12px;
    height: 12px;
    font-weight: 400;
    margin-top: 4px;
  }

  .team {
    display: flex;
    justify-content: space-between;
    width: 100%;
    margin-top: 18px;
    .team-each {
      width: 50%;

      .team-each-item {
        display: flex;
        align-items: center;
        gap: 4px;
        margin-bottom: 4px;

        .no {
          font-size: 10px;
          font-weight: 600;
          margin-right: 2px;
          width: 9px;
          text-align: center;
        }

        .icon {
          width: 22px;
          height: 22px;
          box-sizing: border-box;
          display: flex;
          justify-content: center;
          align-items: center;
          border-radius: 2px;
          border: 0.5px solid rgba(255, 255, 255, 0.10);
          background: rgba(255, 255, 255, 0.10);

          &.noLine {
            img {
              border: none;
            }
          }

          img {
            width: 16px;
            height: 16px;
            border: 0.5px solid #fff;
            border-radius: 100%;
            object-fit: cover;
            display: block;
            overflow: hidden;
          }
        }
      }

      &.team-each-right {
        .team-each-item {
          justify-content: flex-end;

          .no {
            margin-right: 0;
            margin-left: 2px;
          }
        }
      }
    }
  }

  .countdown {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 8px 0;
    gap: 6px;
    margin-bottom: -2px;

    .countdown-label {
      display: flex;
      align-items: center;
      gap: 4px;
      color: #fff;

      .dot {
        width: 8px;
        height: 8px;
        border-radius: 50%;
        background: radial-gradient(circle, #FF6B6B, #F80000);
        box-shadow: 0 0 4px rgba(248, 0, 0, 0.6);
        display: inline-block;
      }

      .label-text {
        font-size: 12px;
        // font-weight: 600;
      }

      .separator {
        font-size: 14px;
        font-weight: 600;
      }
    }

    .countdown-timer {
      display: flex;
      align-items: center;
      gap: 3px;

      .digit {
        width: 14px;
        height: 18px;
        line-height: 18px;
        text-align: center;
        padding-left: 1px;
        // background: #304FFF;
        background: url('../../assets/imgs/header/time-bg.png') no-repeat;
        background-size: 100% 100%;
        background-position: center center;
        border-radius: 0;
        font-size: 16px;
        font-weight: 700;
        color: #F1DF00;
        display: inline-block;
      }

      .unit {
        font-size: 12px;
        // font-weight: 500;
        color: #fff;
        margin: 0 3px;
      }
    }
  }

  .swiper-container {
    width: 100%;
    height: 64px;
    margin-top: -2px;
    padding: 0 12px;
    box-sizing: border-box;

    .swiper-wrapper {
      height: 64px;
    }

    .swiper-slide {
      width: auto;
      height: 64px;
      padding-top: 10px;
    }

    .swiper-item {
      // width: 108px;
      width: 100%;
      height: 54px;
      position: relative;
      background: url(../../assets/imgs/header/swiper.png) no-repeat;
      background-size: 100% 100%;
      border: 0.5px solid #7C8FFF;
      border-radius: 6.8px;
      box-sizing: border-box;

      &.swiper-item-active {
        border-color: #fff;

        &::before {
          content: '';
          position: absolute;
          top: -6px;
          left: 50%;
          transform: translateX(-50%);
          width: 0;
          height: 0;
          border-left: 5px solid transparent;
          border-right: 5px solid transparent;
          border-bottom: 5px solid #fff;
        }
      }
      display: flex;
      flex-direction: column;
      padding: 4px;

      .swiper-header {
        display: flex;
        justify-content: space-between;
        font-size: 6px;
        align-items: center;
        margin-top: -2px;

        .video {
          width: 18.715px;
          img {
            width: 9.14px;
            height: 9.14px;
          }
        }

        .right-icon {
          width: 18.715px;
          img {
            width: 18.715px;
          }
        }
      }

      .swiper-card {
        margin: 0 auto;
        width: 79.724px;
        height: 34.023px;
        background: #fff;
        border-radius: 4.339px;
        margin-top: 2px;

        .swiper-card-header {
          padding: 2px 8.66px;
          display: flex;
          align-items: center;
          justify-content: space-between;

          .icon {
            width: 17.265px;
            height: 17.265px;
            border: 1px solid var(--color-5);
            border-radius: 100%;
            display: flex;
            justify-content: center;
            align-items: center;

            img {
              width: 11.1px;
              display: block;
            }
          }

          .clock {
            img {
              width: 16.7px;
              height: 16.7px;
            }
          }
        }

        .swiper-card-footer {
          text-align: center;
          font-size: 7px;
          line-height: 1;
          margin-top: 2px;
          padding: 2px 1px;
          color: #fff;
          background: #0B0E38;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }

      // img {
      //   width: 100%;
      //   height: 100%;
      //   object-fit: cover;
      //   border-radius: 4px;
      // }

      .swiper-text {
        color: var(--text-white-color);
        font-size: 10px;
        text-align: center;
      }
    }
  }
}
</style>
